export const selector = ({ checkoutCorpo, availability }) => ({
  corpoData: checkoutCorpo.requestData,
  engineName: availability.engine
});
